// @flow
export default class Paging {
  currentPage: number;
  numberOfPages: number;

  constructor({ currentPage, numberOfPages }: $ReadOnly<Paging>) {
    this.currentPage = currentPage;
    this.numberOfPages = numberOfPages;
  }

  goTo(page: number) {
    if (!this.canGoTo(page)) {
      return this.currentPage;
    }

    return page;
  }

  canGoTo(page: number) {
    return page > 0 && page <= this.numberOfPages;
  }

  goToNext() {
    if (!this.canGoToNext()) {
      return this.currentPage;
    }

    return this.currentPage + 1;
  }

  canGoToNext() {
    return this.currentPage < this.numberOfPages;
  }

  goToPrevious() {
    if (!this.canGoToPrevious()) {
      return this.currentPage;
    }

    return this.currentPage - 1;
  }

  canGoToPrevious() {
    return this.currentPage > 1;
  }

  isRequired() {
    return this.numberOfPages > 1;
  }

  isSameAs(other: Paging) {
    return this.currentPage === other.currentPage && this.numberOfPages === other.numberOfPages;
  }
}



// WEBPACK FOOTER //
// ./src/statsradio/modules/pagination/domain/paging.js